import { CircleCheck } from "lucide-react";
import type { ReactNode } from "react";

type ReadAboutDeMinimisProps = {
  bold?: boolean;
  simple?: boolean;
  buttonLabel?: ReactNode;
  onLinkOpened?: () => void;
  capitalised?: boolean;
  completed?: boolean;
  type?: "manuscript" | "audio" | "thesis" | "artwork" | "writer";
  id?: string;
};

const baseUrl = import.meta.env.VITE_PUBLIC_URL || "https://proudlyhuman.org";
const deMinimisSlugByType: Record<NonNullable<ReadAboutDeMinimisProps["type"]>, string> = {
  manuscript: "manuscript",
  audio: "audio",
  thesis: "thesis",
  artwork: "artwork",
  writer: "manuscript",
};

export default function ReadAboutDeMinimis({
  bold = false,
  simple = false,
  buttonLabel,
  onLinkOpened,
  capitalised = true,
  completed = false,
  type = "manuscript",
  id,
}: ReadAboutDeMinimisProps) {
  const handleClick = () => {
    window.open(`${baseUrl}/de-minimis/${deMinimisSlugByType[type]}?canGoBack=true`, "_blank");
    onLinkOpened?.();
  };

  return (
    <span className={bold ? "font-bold" : ""}>
      {simple ? "" : <>{capitalised ? "Read more about " : "read about "}</>}{" "}
      <button
        id={id}
        type="button"
        onClick={handleClick}
        className="underline hover:text-brand-green-primary transition-colors cursor-pointer"
      >
        {buttonLabel ?? <i>de minimis</i>}
      </button>
      {simple ? "" : " use of AI."}
      {completed && (
        <CircleCheck className="inline-block w-5 h-5 text-primary align-text-bottom ml-1.5 animate-in fade-in zoom-in duration-300" />
      )}
    </span>
  );
}
